/** Initializes the navigational elements. */
export function init(): void {
	const body = document.body as HTMLBodyElement;
	const slideover = document.getElementById("header-nav-slideover");
	const menuButton = document.getElementById("rt-menu-button");

	if (!slideover || !menuButton) return;

	window.addEventListener("resize", () => {
		handleResize();
	});

	menuButton.addEventListener("click", () => {
		toggleNav();
	});
	slideover.addEventListener("click", (e) => {
		handleSlideoverClick(
			e.currentTarget as HTMLElement,
			e.target as HTMLElement,
		);
	});

	/*
      Handle switch between mobile and desktop
      */
	const handleResize = () => {
		const { classList } = body;
		if (window.innerWidth > 869) {
			if (classList.contains("header-searchcomplete-open")) {
				//If search is open we don't want to remove no-scroll
			} else {
				classList.remove("rt-noscroll");
			}

			slideover.classList.remove("header-nav-open");
			classList.remove("header-nav-open");
		} else {
			if (!classList.contains("header-nav-open")) {
				//If nav is open we don't want to remove no-scroll
				classList.remove("rt-noscroll");
			}

			classList.remove("header-searchcomplete-open");
		}
	};

	const toggleNav = () => {
		const { classList } = body;
		if (classList.contains("header-nav-open")) {
			toggleNavOff();
		} else {
			toggleNavOn();
		}
	};

	const toggleNavOn = () => {
		const { classList } = body;
		slideover.classList.add("header-nav-open");
		classList.add("rt-noscroll");
		classList.add("header-nav-open");
	};

	const toggleNavOff = () => {
		slideover.classList.remove("header-nav-open");
		const { classList } = body;
		classList.remove("rt-noscroll");
		classList.remove("header-nav-open");
	};

	// Close nav if the page is clicked anywhere other than in the nav itself.
	const handleSlideoverClick = (target: HTMLElement, parent: HTMLElement) => {
		if (target !== parent) {
			return;
		}
		toggleNav();
	};
}
